module.exports = __WEBPACK_EXTERNAL_MODULE_45__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","getMonth"],"commonjs":"date-fns/get_month/index","commonjs2":"date-fns/get_month/index","amd":"date-fns/get_month/index"}
// module id = 45
// module chunks = 0